export { default } from './ObservationSearchBar.component';
